export default (context) => 'Provide the answer directly and precisely without additional explanations, introductions, or conclusions. Do not use markup language unless explicitly requested.';
//# sourceMappingURL=noExplanations.js.map